import { useQuery } from "@tanstack/react-query";
import studentApi from "../../api/studentApi";

export const useGetStudentOfCurrentMonth = () => {
    return useQuery({
        queryKey: ["student-current-month"],
        queryFn: () => studentApi.getTotalStudentOfCurrentMonth(),
    });
};
